// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d937d099","732":"4cbffed1","977":"016a7df8"}[chunkId] + ".chunk.js";
};